/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

angular.module('prism-ui.components.data').factory('UsersResourceFactory', function ($resource: JS5Function, EndPointService: JS5Object) {
    return $resource(EndPointService.userEndPoint, {
            id: '@id'
        },
        {
            query: {
                method: 'GET',
                headers: {'api-version': '2.0'},
                params: {
                    fetchOffset: '@fetchOffset',
                    fetchLimit: '@fetchLimit',
                    filter: '@filter'
                },
                isArray: true,
            },
            createUser: {
                method: 'POST',
                url: EndPointService.userEndPoint,
                headers: {'api-version': '2.0'},
                isArray: false
            },
            getUser: {
                method: 'GET',
                url: EndPointService.userEndPoint + '/:id',
                headers: {'api-version': '2.0'},
                isArray: false
            },
            getCurrentUser: {
                method: 'GET',
                url: EndPointService.userEndPoint + '/current',
                headers: {'api-version': '2.0'},
                isArray: false
            },
            updateUser: {
                method: 'PUT',
                url: EndPointService.userEndPoint + '/:id',
                headers: {'api-version': '2.0'},
                isArray: false
            },
            deleteUser: {
                method: 'DELETE',
                url: EndPointService.userEndPoint + '/:id',
                headers: {'api-version': '2.0'},
                isArray: false
            },
            getUserRoles: {
                method: 'GET',
                url: EndPointService.userEndPoint + '/:id/roles',
                headers: {'api-version': '2.0'},
                isArray: true
            },
            addUserRole: {
                method: 'POST',
                url: EndPointService.userEndPoint + '/:id/roles/:roleId',
                headers: {'api-version': '2.0'},
                params: {
                    roleId: '@roleId'
                },
                isArray: false
            },
            removeUserRole: {
                method: 'DELETE',
                url: EndPointService.userEndPoint + '/:id/roles/:roleId',
                headers: {'api-version': '2.0'},
                params: {
                    roleId: '@roleId'
                },
                isArray: false
            },
            getPasswordRequirements: {
                method: 'GET',
                url: `${EndPointService.userEndPoint}/password`,
                headers: {'api-version': '2.0'},
                isArray: false
            },
            updatePassword: {
                method: 'PUT',
                url: `${EndPointService.userEndPoint}/password`,
                headers: {'api-version': '2.0'},
                isArray: false
            },
            sendResetPasswordEmail: {
                method: 'PUT',
                url: `${EndPointService.userEndPoint}/:id/password`,
                headers: {'api-version': '2.0'},
                isArray: false
            },
        });
});
